import React from "react"
import { useTranslation } from "react-i18next"

import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "./styles/_product-card-legend.scss"

export const ProductCardLegend = React.memo(() => {
  const { t } = useTranslation()
  return (
    <div className="product-card-legend" aria-hidden>
      <div className="product-card-legend__item">
        <Icon name={IconName.EURO} aria-hidden />
        {t("Product.ListPrices")}
      </div>
      <div className="product-card-legend__item">
        <Icon name={IconName.CONFIGURATION} aria-hidden />
        {t("Product.Configuration.Configuration")}
      </div>
      <div className="product-card-legend__item">
        <Icon name={IconName.DIMENSIONING} aria-hidden />
        {t("Product.Configuration.Dimensioning")}
      </div>
    </div>
  )
})
